import * as React from "react";
import PagedModel from "./PagedModel";

interface PaginationProps {
  page: PagedModel<any>;
  changePage: (number: number) => any;
}

export default class PaginationBar extends React.Component<PaginationProps> {
  render() {
    const startItemIndex = this.props.page.page.totalElements
      ? this.props.page.page.number * this.props.page.page.size + 1
      : this.props.page.page.totalElements;
    const endItemIndex = this.props.page.page.totalElements
      ? startItemIndex + this.props.page.content.length - 1
      : this.props.page.page.totalElements;
    return (
      <div className="pagination-bar h-flex centered">
        <span>{`${i18n["PaginationBar.Label"]} ${startItemIndex}-${endItemIndex} ${i18n["PaginationBar.Total"]} ${this.props.page.page.totalElements}`}</span>
        {this.props.page.page.number !== 0 ? (
          <i
            className="ic_chevron_left"
            onClick={() => this.props.changePage(this.props.page.page.number - 1)}
          />
        ) : (
          <i className="ic_chevron_left disabled" />
        )}
        {this.props.page.page.number !== this.props.page.page.totalPages - 1 ? (
          <i
            className="ic_chevron_right"
            onClick={() => this.props.changePage(this.props.page.page.number + 1)}
          />
        ) : (
          <i className="ic_chevron_right disabled" />
        )}
      </div>
    );
  }
}
